export default async function fetchFontFamily(
  fontValue,
  _params,
  containerProps,
) {
  const { swellTheme } = containerProps;

  return swellTheme.resolveFontSetting(fontValue);
}
